import { EdgelessCRUDExtension } from '@blocksuite/affine-block-surface';
import { type SurfaceRefProps } from '@blocksuite/affine-model';
import type { Command } from '@blocksuite/std';
import { GfxPrimitiveElementModel } from '@blocksuite/std/gfx';
import type { BlockModel } from '@blocksuite/store';

export const insertSurfaceRefBlockCommand: Command<
  {
    reference: string;
    place: 'after' | 'before';
    removeEmptyLine?: boolean;
    selectedModels?: BlockModel[];
  },
  {
    insertedSurfaceRefBlockId: string;
  }
> = (ctx, next) => {
  const { selectedModels, reference, place, removeEmptyLine, std } = ctx;
  if (!selectedModels?.length) return;

  const targetModel =
    place === 'before'
      ? selectedModels[0]
      : selectedModels[selectedModels.length - 1];

  const surfaceRefProps: Partial<SurfaceRefProps> & {
    flavour: 'affine:surface-ref';
  } = {
    flavour: 'affine:surface-ref',
    reference,
  };

  const crud = std.get(EdgelessCRUDExtension);
  let element = crud.getElementById(reference);

  if (!element) {
    const surfaceBlocks = [...std.store.blocks.values()].filter(
      b => b.flavour === 'affine:surface'
    ) as any[];
    for (const surface of surfaceBlocks) {
      if (surface.elements && typeof surface.elements.get === 'function') {
        const yEl = surface.elements.get(reference);
        if (yEl) {
          const type = typeof yEl.get === 'function' ? (yEl.get('type') || 'mindmap') : (yEl.type || 'mindmap');
          surfaceRefProps.refFlavour = type;
          element = yEl;
          break;
        }
      }
    }
  }

  if (!element) {
    console.error(`reference not found ${reference}`);
    return;
  }

  if (!surfaceRefProps.refFlavour) {
    surfaceRefProps.refFlavour =
      element instanceof GfxPrimitiveElementModel
        ? element.type
        : (element.flavour || (typeof element.get === 'function' ? element.get('type') : 'mindmap'));
  }

  const result = std.store.addSiblingBlocks(
    targetModel,
    [surfaceRefProps],
    place
  );
  if (result.length === 0) return;

  if (removeEmptyLine && targetModel.text?.length === 0) {
    std.store.deleteBlock(targetModel);
  }

  next({
    insertedSurfaceRefBlockId: result[0],
  });
};
